import { ORDER_MAGIC_LINK_TTL_SECONDS } from '@gg/shared';

/**
 * Addresses typed on the confirmation screen by a buyer without a session (record 0027, R1):
 * kept in this browser until the confirmation email's link opens /me/invite or the team page,
 * which pre-fill them. localStorage, not sessionStorage: the email link opens a new tab. Kept as
 * long as that link lives; cleared once sent.
 */
export type InviteDraftKey = 'invite' | `team:${string}`;

const key = (k: InviteDraftKey) => `gg_invite_draft:${k}`;

export function saveInviteDraft(k: InviteDraftKey, emails: string[]): void {
  try {
    localStorage.setItem(key(k), JSON.stringify({ emails, savedAt: Date.now() }));
  } catch {
    // No storage: the addresses are typed again from the profile.
  }
}

export function readInviteDraft(k: InviteDraftKey | undefined): string[] {
  if (!k) return [];
  try {
    const raw = localStorage.getItem(key(k));
    if (!raw) return [];
    const { emails, savedAt } = JSON.parse(raw) as { emails: unknown; savedAt: number };
    if (Date.now() - savedAt > ORDER_MAGIC_LINK_TTL_SECONDS * 1000 || !Array.isArray(emails)) {
      localStorage.removeItem(key(k));
      return [];
    }
    return emails.filter((e): e is string => typeof e === 'string');
  } catch {
    return [];
  }
}

export function clearInviteDraft(k: InviteDraftKey | undefined): void {
  if (!k) return;
  try {
    localStorage.removeItem(key(k));
  } catch {
    // ignore
  }
}
